import { Injectable } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { UnsupportedBrowserModalComponent } from "app/shared/components/unsupported-browser-modal/unsupported-browser-modal.component";

export enum BrowserName {
  CHROME = "chrome",
  EDGE = "edge",
  SAFARI = "safari",
  FIREFOX = "firefox",
  OPERA = "opera",
  NO_BROWSER_DETECTION = "no browser detection",
}

@Injectable({
  providedIn: "root",
})
export class UnsupportedBrowserService {
  private isUnsupportedBrowserDialogOpen: boolean = false;
  constructor(private dialog: MatDialog) {}

  public showUnsupportedBrowserModal(): void {
    if (this.isUnsupportedBrowserDialogOpen) {
      return;
    }
    const isSupportedBrowser: boolean = this.isSupportedBrowser();

    if (!isSupportedBrowser) {
      this.isUnsupportedBrowserDialogOpen = true;
      const dialogRef: MatDialogRef<UnsupportedBrowserModalComponent> =
        this.dialog.open(UnsupportedBrowserModalComponent);
      dialogRef.afterClosed().subscribe(() => {
        this.isUnsupportedBrowserDialogOpen = false;
      });
    }
  }
  private isSupportedBrowser(): boolean {
    const browserName: BrowserName = this.getBrowserName();
    return (
      browserName === BrowserName.CHROME || browserName === BrowserName.EDGE
    );
  }

  private getBrowserName(): BrowserName {
    const userAgent: string = navigator.userAgent;
    let browserName: BrowserName = BrowserName.NO_BROWSER_DETECTION;

    // The order of this if else statement is important because userAgent in Edge or Opera includes Chrome & Safari strings
    // e.g In Opera: Mozilla / 5.0(Macintosh; Intel Mac OS X 10_15_7) AppleWebKit / 537.36(KHTML, like Gecko) Chrome / 106.0.0.0 Safari / 537.36 OPR / 92.0.0.0
    if (userAgent.match(/edg/i)) {
      browserName = BrowserName.EDGE;
    } else if (userAgent.match(/opr/i)) {
      browserName = BrowserName.OPERA;
    } else if (
      userAgent.match(/safari/i) &&
      userAgent.match(/chrome|chromium/i)
    ) {
      browserName = BrowserName.CHROME;
    } else if (userAgent.match(/safari/i)) {
      browserName = BrowserName.SAFARI;
    } else if (userAgent.match(/firefox|fxios/i)) {
      browserName = BrowserName.FIREFOX;
    }

    return browserName;
  }
}
